export default {
    successAlert: null,
    successMessage: null,
    dangerAlert: null,
    dangerMessage: null,
    register_result: null
}